<!-- VIEW MODE  -->
<div data-test="system-settings-page" [class]="floatingPageClasses()">
  @if (isLoading()) {
    <lib-overlay-loader />
  } @else {
    @if (!editMode() && !isLoading()) {
      <h5
        class="text-neutral-900 font-semibold text-2xl"
        [class.mb-2xl]="!floating()"
        [class.mb-lg]="floating()">
        {{ 'system_settings_screen_title' | transloco }}
      </h5>

      <!-- Floating: the tabs and their content are one card -->
      <lib-tabs
        data-test="system-settings-card"
        [class]="floating() ? 'block floating-card p-2xl' : ''"
        [tabsBorder]="true">
        <lib-tab
          [tabTitle]="'system_settings_screen_company_tab_label' | transloco">
          <app-view-setting-working-days [workingDays]="workingDays()" />
        </lib-tab>
      </lib-tabs>
    } @else {
      <app-edit-setting-working-days
        data-test="system-settings-edit"
        [class]="floating() ? 'block floating-card p-2xl' : ''"
        [workingDays]="workingDays()" />
    }
  }
</div>

<!-- VIEW MODE  -->
